import * as React from 'react';
import { Slider } from '@cian/slider';
import { Responsive } from '@cian/ui-kit';

import { OnboardingSlidesContainer, OnboardingSwitcherContainer } from '../index';
import { OnboardingLayout } from '../../../../components/OnboardingLayout';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { trackShowOnboardingModal } from '../../utils';

import slide1Src from './assets/onboarding-1.svg';
import slide2Src from './assets/onboarding-2.svg';

export type TOnboardingSlide = {
  src: string;
  title: string;
  text: string;
  hasNextButton?: boolean;
  hasPrevButton?: boolean;
  hasFinishButton?: boolean;
};

const ONBOARDING_SLIDES: TOnboardingSlide[] = [
  {
    src: slide1Src,
    title: 'Нужные данные уже есть',
    text: 'Знаем, сколько стоит ваша квартира, оценили доход от аренды, собрали ставки по банковским вкладам',
    hasNextButton: true,
  },
  {
    src: slide2Src,
    title: 'Мы всё посчитали',
    text: 'Отметили преимущества каждого варианта — можете выбрать подходящий сценарий',
    hasPrevButton: true,
    hasFinishButton: true,
  },
];

export const OnboardingContainer: React.FC = () => {
  return (
    <ActionAfterViewObserver callback={trackShowOnboardingModal}>
      <>
        <Responsive desktop tablet>
          <OnboardingLayout testId="OnboardingSlideDesktop">
            <Slider>
              <OnboardingSlidesContainer slides={ONBOARDING_SLIDES} />
              <OnboardingSwitcherContainer slides={ONBOARDING_SLIDES} />
            </Slider>
          </OnboardingLayout>
        </Responsive>
        <Responsive phone>
          <OnboardingLayout isMobile testId="OnboardingSlideMobile">
            <Slider>
              <OnboardingSlidesContainer slides={ONBOARDING_SLIDES} isMobile />
              <OnboardingSwitcherContainer slides={ONBOARDING_SLIDES} isMobile />
            </Slider>
          </OnboardingLayout>
        </Responsive>
      </>
    </ActionAfterViewObserver>
  );
};
